import { createSlice } from "@reduxjs/toolkit";
const reducer = createSlice({
    name: "patientDetails",
    initialState: {},
    reducers: {
        addSubMemberType(state, action) {
            return state = action.payload;
        },
    },
});
export const { addSubMemberType } = reducer.actions;
export default reducer.reducer;
